import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton} from 'reactis-datagrid';
import {Button, ButtonToolbar,Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import {actions as datagridActions} from 'reactis-datagrid';
import immutable from 'immutable';
import {bindActionCreators} from 'redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import store from "store2";


export default class List extends Component {

	constructor(props) {
		super(props);

		const rendererLink = (val, row) => {
			val = DbInfo.TemplateType.get(val);
			return <div>
					<a href={'/template/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>
				</div>
		};

		this.columnModel = [
			{
				name: 'type',
				title: 'Typ',
				field: 'type',
				renderer: rendererLink
			},
			{
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 40,
				align: 'center',
				viewport: 'tablet'
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				style: {whiteSpace: 'nowrap'},
				width: 30,
				align: 'center',
				sortable: false,
				viewport: 'tablet',
				renderer: (val, row) => {
					return (
						<a href={'/template/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil"></i> <span className="vp-desktop">Upravit</span>
						</a>
					);
				}
			}
		];

		const filterSchema = {
			/*id: { class: FilterInput },
			fulltext: { class: SearchInput },
			title: { class: FilterInput },
			subject: { class: FilterInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}*/
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-template');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'id', 'direction': 'asc'};
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('template.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('template.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('template', DbInfo.TemplateType.get(row.type), row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		return (
			<Datagrid
				ref="datagrid"
				id="template"
				api="template.getList"
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				defaultSort={this.defaultSort}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/containers/Template/List.js